import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import isEmpty from 'lodash/isEmpty';

import * as pageActions from '../../../../../../data/redux/page_details/actions';
import * as botBuilderActions from '../../../../../../data/redux/botbuilder_details/actions';

import { showMessage, log } from '../../../../../../data/config/utils';
import { ROUTE_PATH, PERMISSIONS, APP_PAGES } from '../../../../../../data/config/constants';

import ShowMessage from '../../../../../../components/showmessage';
import CustomHeader from '../../../../../../components/customheader';
import PageHeaderLoader from '../../../../../../components/pageheader/loaders';
import ModalFooter from '../../../../../../components/modalfooter';
import FlowDiagram from './flowdiagram';
import EntityNodeForm from './entitynodeform';
import WorkflowNodeForm from './workflownodeform';

class WorkflowDiagram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer_data: {
        title: "Title",
        show_create_entity_node_form: false,
        show_edit_entity_node_form: false,
        show_create_workflow_node_form: false,
        show_edit_workflow_node_form: false,
      },
      workflow_node_details: {},
    };
  }

  componentWillMount() {
    let { actions } = this.props;
    actions.pageChanged(APP_PAGES.WORKFLOWS, APP_PAGES.BOT_BUILDER);
  }

  componentDidMount() {
    const { actions, match, history, botbuilder_details } = this.props;
    if (isEmpty(botbuilder_details.preemptive_data.actions) || isEmpty(botbuilder_details.preemptive_data.variables)) {
      actions.getPreemptiveData();
    }
    if (isEmpty(botbuilder_details.workflows)) {
      actions.getWorkFlowData();
    }
    if (match && match.params && match.params.wid) {
      actions.getWorkflowModel({ wid: match.params.wid });
    } else {
      history.goBack();
      showMessage('warning', 'workflow id is missing');
    }
  }

  handleCloseDrawer = () => {
    this.setState({
      drawer_data: {
        title: "Title",
        show_create_entity_node_form: false,
        show_edit_entity_node_form: false,
        show_create_workflow_node_form: false,
        show_edit_workflow_node_form: false,
      },
      workflow_node_details: {},
    });
    this.props.actions.clearWorkflowNodeDetails();
  };

  goBackToWorkflow = () => {
    const { actions, history } = this.props;
    actions.resetWorkflowModel();
    history.goBack();
  };

  editEntityNode = (node) => {
    log('edit entity node', node);
    const { actions, match, isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.UPDATE)) {
      if (node && node.nodeId) {
        const payload = {
          wid: match.params.wid,
          nodeId: node.nodeId
        };
        actions.getWorkflowNodeDetails(payload, () => this.setState({
          drawer_data: {
            title: "Edit Entity Node",
            show_create_entity_node_form: false,
            show_edit_entity_node_form: true,
            show_create_workflow_node_form: false,
            show_edit_workflow_node_form: false,
          }
        }));
      } else {
        showMessage('warning', 'node id is missing');
      }
    } else {
      showMessage('warning', 'you have not permission to update workflow');
    }
  };

  createEntityNode = (entity) => {
    const { actions, match, isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.UPDATE)) {
      this.setState({
        drawer_data: {
          title: "Create Entity Node",
          show_create_entity_node_form: true,
          show_edit_entity_node_form: false,
          show_create_workflow_node_form: false,
          show_edit_workflow_node_form: false,
        },
        workflow_node_details: {}
      });
      actions.updateBotBuilderState(entity, 'active_workflow_node_details.parentNode');
      actions.updateBotBuilderState(match.params.wid, 'active_workflow_node_details.wid');
    } else {
      showMessage('warning', 'you have not permission to update workflow');
    }
  };

  createWorkflowNode = (parent_node) => {
    log('create workflow node', parent_node);
    const { isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.UPDATE)) {
      this.setState({
        drawer_data: {
          title: "Create Workflow Node",
          show_create_entity_node_form: false,
          show_edit_entity_node_form: false,
          show_create_workflow_node_form: true,
          show_edit_workflow_node_form: false,
        },
        workflow_node_details: {
          parentNode: parent_node,
        }
      });
    } else {
      showMessage('warning', 'you have not permission to update workflow');
    }
  };

  editWorkflowNode = (node) => {
    log('edit workflow node', node);
    const { botbuilder_details, isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.UPDATE)) {
      this.setState({
        drawer_data: {
          title: "Edit Workflow Node",
          show_create_entity_node_form: false,
          show_edit_entity_node_form: false,
          show_create_workflow_node_form: false,
          show_edit_workflow_node_form: true,
        },
        workflow_node_details: {
          oldWorkflow: node,
          UIRepresentation: botbuilder_details.workflow_model,
          nextNodeId: node.nextNodeId,
          nextWId: node.nextWId
        }
      });
    } else {
      showMessage('warning', 'you have not permission to update workflow');
    }
  };

  saveWorkflowDiagram = () => {
    const { actions, botbuilder_details, history, match, isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.UPDATE)) {
      if (match && match.params && match.params.wid) {
        const payload = {
          wid: match.params.wid,
          UIRepresentation: botbuilder_details.workflow_model
        };
        actions.saveWorkflowDiagram(payload, this.goBackToWorkflow);
      } else {
        history.goBack();
        showMessage('warning', 'workflow id is missing');
      }
    } else {
      showMessage('warning', 'you have not permission to update workflow');
    }
  };

  handleCreateEntityNodeClick = () => {
    const { actions, botbuilder_details } = this.props;
    actions.createEntityTypeNode(botbuilder_details.active_workflow_node_details, this.handleCloseDrawer);
  };

  handleUpdateEntityNodeClick = () => {
    const { actions, botbuilder_details } = this.props;
    actions.updateEntityTypeNode(botbuilder_details.active_workflow_node_details, this.handleCloseDrawer);
  };

  handleCreateWorkflowNodeClick = () => {
    const { actions } = this.props;
    const { workflow_node_details } = this.state;
    actions.createWorkflowTypeNode(workflow_node_details, this.handleCloseDrawer);
  };

  handleUpdateWorkflowNodeClick = () => {
    const { actions } = this.props;
    const { workflow_node_details } = this.state;
    actions.updateWorkflowTypeNode(workflow_node_details, this.handleCloseDrawer);
  };

  entityNodeNameChanged = e => this.props.actions.updateBotBuilderState(e.target.value, 'active_workflow_node_details.name');

  entityNodeActionChanged = action => this.props.actions.updateBotBuilderState(action === undefined ? "" : action, 'active_workflow_node_details.action');

  entityNodeVariableChanged = variable => this.props.actions.updateBotBuilderState(variable === undefined ? "" : variable, 'active_workflow_node_details.variable');

  entityNodeEventTagChanged = tag => this.props.actions.updateBotBuilderState(tag === undefined ? "" : tag, 'active_workflow_node_details.tag');

  entityNodeEventTagTypeChanged = type => this.props.actions.updateBotBuilderState(type === undefined ? "" : type, 'active_workflow_node_details.tag_type');

  addEntityNodeMessageBefore = message => this.props.actions.updateBotBuilderState(message, `active_workflow_node_details.message_before.${this.props.botbuilder_details.active_workflow_node_details.message_before.length}`);

  deleteEntityNodeMessageBefore = index => this.props.actions.deleteBotBuilderState(`active_workflow_node_details.message_before.${index}`);

  addEntityNodeMessageAfter = message => this.props.actions.updateBotBuilderState(message, `active_workflow_node_details.message_after.${this.props.botbuilder_details.active_workflow_node_details.message_after.length}`);

  deleteEntityNodeMessageAfter = index => this.props.actions.deleteBotBuilderState(`active_workflow_node_details.message_after.${index}`);

  entityNodeStart = bool => this.props.actions.updateBotBuilderState(bool, 'active_workflow_node_details.start');

  entityNodeEnd = bool => this.props.actions.updateBotBuilderState(bool, 'active_workflow_node_details.end');

  entityNodeAuthRequiredChanged = bool => this.props.actions.updateBotBuilderState(bool, 'active_workflow_node_details.auth_required');

  entityNodeTargetWorkflowChanged = (value, index) => this.props.actions.updateBotBuilderState(value, `active_workflow_node_details.outEdges.${index}.target.wid`);

  entityNodeTargetNodeChanged = (value, index) => this.props.actions.updateBotBuilderState(value, `active_workflow_node_details.outEdges.${index}.target.nodeId`);

  entityNodeLabelChanged = (value, index) => this.props.actions.updateBotBuilderState(value, `active_workflow_node_details.outEdges.${index}.label`);

  entityNodeCustomRuleChanged = (bool, index) => this.props.actions.updateBotBuilderState(bool, `active_workflow_node_details.outEdges.${index}.customRule`);

  entityNodeRuleChanged = (value, index) => this.props.actions.updateBotBuilderState(value, `active_workflow_node_details.outEdges.${index}.rule`);

  entityNodeResetParameterKeyChanged = (value, index, parameter_index) => this.props.actions.updateBotBuilderState(value, `active_workflow_node_details.outEdges.${index}.resetParameters.${parameter_index}.key`);

  entityNodeResetParameterValueChanged = (value, index, parameter_index) => this.props.actions.updateBotBuilderState(value, `active_workflow_node_details.outEdges.${index}.resetParameters.${parameter_index}.value`);

  deleteEntityNodeResetParameter = (index, parameter_index) => this.props.actions.deleteBotBuilderState(`active_workflow_node_details.outEdges.${index}.resetParameters.${parameter_index}`);

  addEntityNodeResetParameter = (value, index, parameter_index) => this.props.actions.updateBotBuilderState(value, `active_workflow_node_details.outEdges.${index}.resetParameters.${parameter_index}`);

  onChangeWorkflow = nextWId => {
    const { workflow_node_details } = this.state;
    this.setState({
      workflow_node_details: {
        ...workflow_node_details,
        nextWId,
        nextNodeId: undefined
      }
    });
  };

  onChangeWorkflowNode = nextNodeId => {
    const { workflow_node_details } = this.state;
    this.setState({
      workflow_node_details: {
        ...workflow_node_details,
        nextNodeId
      }
    });
  };

  render() {
    const { isActionPermitted, page_details, botbuilder_details, history, actions } = this.props;
    const { drawer_data, workflow_node_details } = this.state;

    if (botbuilder_details.loaders.workflow_model_loading && !botbuilder_details.loaders.workflow_model_loaded) {
      return (
        <div className="ori-full-parent-height ori-full-width ori-flex-column">
          <PageHeaderLoader container_class="ori-lr-pad-15" bottom_bordered />
          <div className="ori-full-flex ori-bg-grid">&nbsp;</div>
        </div>
      );
    } else if (!botbuilder_details.loaders.workflow_model_loading && botbuilder_details.loaders.workflow_model_loaded) {
      return (
        <div >
          <CustomHeader container_class="ori-lr-pad-10" title={botbuilder_details.workflow_model_title} first_button_text="Cancel" onClickFirstButton={this.goBackToWorkflow} second_button_type="primary" second_button_text="Save" onClickSecondButton={this.saveWorkflowDiagram} show_first_button show_second_button bottom_border_light />
          <div className="ori-flex-column ori-flex-no-wrap ori-overflow-x-hidden" style={{ minHeight: `${page_details.device_data.screen_height - 60 - 55}px` }}>
            <FlowDiagram is_update_allowed={isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.UPDATE)} model={botbuilder_details.workflow_model} diagramOnChange={actions.updateWorkflowModel} editEntityNode={this.editEntityNode} createEntityNode={this.createEntityNode} editWorkflowNode={this.editWorkflowNode} createWorkflowNode={this.createWorkflowNode} />
          </div>
          <Drawer className="ori-drawer ori-drawer-title-primary ori-drawer-body-with-header ori-drawer-body-no-pad" width={page_details.device_data.screen_width < 480 ? page_details.device_data.screen_width : 460} style={{ height: 'calc(100% - 60px)', overflow: 'hidden', padding: '0px 0px 62px 0px' }} title={drawer_data.title} visible={drawer_data.show_create_entity_node_form || drawer_data.show_edit_entity_node_form || drawer_data.show_create_workflow_node_form || drawer_data.show_edit_workflow_node_form} placement="right" maskClosable={false} onClose={this.handleCloseDrawer}>
            {
              (drawer_data.show_create_entity_node_form || drawer_data.show_edit_entity_node_form) &&
              <div className="ori-full-parent-height ori-b-pad-65">
                <EntityNodeForm getPreemptiveData={actions.getPreemptiveData} preemptive_data={botbuilder_details.preemptive_data} node_details={botbuilder_details.active_workflow_node_details} possible_rules={botbuilder_details.active_node_possible_rules} workflows={botbuilder_details.workflows} onChangeName={this.entityNodeNameChanged} onChangeAction={this.entityNodeActionChanged} onChangeVariable={this.entityNodeVariableChanged} onChangeEventTag={this.entityNodeEventTagChanged} onChangeEventTagType={this.entityNodeEventTagTypeChanged} addMessageBefore={this.addEntityNodeMessageBefore} onClickDeleteMessageBefore={this.deleteEntityNodeMessageBefore} addMessageAfter={this.addEntityNodeMessageAfter} onClickDeleteMessageAfter={this.deleteEntityNodeMessageAfter} onChangeStart={this.entityNodeStart} onChangeEnd={this.entityNodeEnd} onChangeAuthRequired={this.entityNodeAuthRequiredChanged} show_edit_edges={drawer_data.show_edit_entity_node_form} onChangeTargetWorkflow={this.entityNodeTargetWorkflowChanged} onChangeTargetNode={this.entityNodeTargetNodeChanged} onChangeLabel={this.entityNodeLabelChanged} onChangeCustomRule={this.entityNodeCustomRuleChanged} onChangeRule={this.entityNodeRuleChanged} onChangeResetParameterKey={this.entityNodeResetParameterKeyChanged} onChangeResetParameterValue={this.entityNodeResetParameterValueChanged} deleteResetParameter={this.deleteEntityNodeResetParameter} addResetParameter={this.addEntityNodeResetParameter} />
                {
                  drawer_data.show_create_entity_node_form &&
                  <div className="ori-absolute ori-full-width ori-align-bottom ori-b-pad-5 ori-align-left">
                    <ModalFooter button_ok_text="save" button_ok_type="submit" loading={botbuilder_details.loaders.workflow_type_node_changing} handleCancelClick={this.handleCloseDrawer} handleOkClick={this.handleCreateEntityNodeClick} capsule_button />
                  </div>
                }
                {
                  drawer_data.show_edit_entity_node_form &&
                  <div className="ori-absolute ori-full-width ori-align-bottom ori-b-pad-5 ori-align-left">
                    <ModalFooter button_ok_text="update" loading={botbuilder_details.loaders.workflow_type_node_changing} handleCancelClick={this.handleCloseDrawer} handleOkClick={this.handleUpdateEntityNodeClick} capsule_button />
                  </div>
                }
              </div>
            }
            {
              drawer_data.show_create_workflow_node_form &&
              <div className="ori-full-parent-height ori-b-pad-65">
                <WorkflowNodeForm workflows={botbuilder_details.workflows} workflow_node_details={workflow_node_details} button_ok_text="Create" loading={botbuilder_details.loaders.workflow_type_node_changing} onChangeWorkflow={this.onChangeWorkflow} onChangeWorkflowNode={this.onChangeWorkflowNode} handleCancelClick={this.handleCloseDrawer} handleOkClick={this.handleCreateWorkflowNodeClick} />
              </div>
            }
            {
              drawer_data.show_edit_workflow_node_form &&
              <div className="ori-full-parent-height ori-b-pad-65">
                <WorkflowNodeForm workflows={botbuilder_details.workflows} workflow_node_details={workflow_node_details} button_ok_text="Save" loading={botbuilder_details.loaders.workflow_type_node_changing} onChangeWorkflow={this.onChangeWorkflow} onChangeWorkflowNode={this.onChangeWorkflowNode} handleCancelClick={this.handleCloseDrawer} handleOkClick={this.handleUpdateWorkflowNodeClick} />
              </div>
            }
            {
              botbuilder_details.loaders.workflow_diagram_node_changing &&
              <div className="ori-absolute ori-align-full">&nbsp;</div>
            }
          </Drawer>
        </div>
      );
    } else if (!botbuilder_details.loaders.workflow_model_loading && !botbuilder_details.loaders.workflow_model_loaded) {
      return (
        <ShowMessage title="Error" message="unable to load workflow modal. please check your intenet connection and reload the page." height={150} width={150} show_button button_type="primary" button_class="ori-border-radius-20 " button_text="Go Back" handleButtonClick={() => history.push(ROUTE_PATH.WORKFLOWS)} error />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    page_details: state.page_details,
    botbuilder_details: state.botbuilder_details,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, pageActions, botBuilderActions), dispatch)
  };
};

WorkflowDiagram.propTypes = {
  page_details: PropTypes.object,
  botbuilder_details: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(WorkflowDiagram);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/workflows/workflowdiagram/index.js